import axios from "axios";

export const TOKEN_TTL_MS = 24 * 60 * 60 * 1000;

const readToken = () => {
  try {
    const raw = localStorage.getItem("token");
    if (!raw) return null;
    const { token, timestamp } = JSON.parse(raw);
    if (!token || !timestamp) return null;
    if (Date.now() - timestamp > TOKEN_TTL_MS) {
      localStorage.removeItem("token");
      return null;
    }
    return token;
  } catch {
    return null;
  }
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKENDIP,
});

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `bearer ${token}`;
  }
  return config;
});

export default api;
